import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { supabase } from '../lib/supabase';
import { ArrowLeft, ArrowUpRight, ArrowDownLeft } from 'lucide-react';
import { formatCurrency } from '../utils/formatters';

export function TransactionView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [transaction, setTransaction] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTransaction();
  }, [id]);

  const fetchTransaction = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .from('business_transactions')
        .select('*')
        .eq('id', id)
        .single();

      if (error) throw error;
      setTransaction(data);
    } catch (err) {
      console.error('Error fetching transaction:', err);
      navigate('/business');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="space-y-6">
        <button
          onClick={() => navigate('/business')}
          className="flex items-center gap-2 text-gray-400 hover:text-white transition-colors"
        >
          <ArrowLeft className="w-5 h-5" />
          <span>Back to Business</span>
        </button>

        {loading ? (
          <div className="text-center py-8">Loading...</div>
        ) : transaction ? (
          <div className="space-y-6">
            <div className="flex items-center justify-between">
              <h1 className="text-3xl font-bold">{transaction.business_name}</h1>
              <div className={`flex items-center gap-2 ${
                transaction.type === 'invoice' ? 'text-green-500' : 'text-red-500'
              }`}>
                {transaction.type === 'invoice' ? (
                  <ArrowUpRight className="w-5 h-5" />
                ) : (
                  <ArrowDownLeft className="w-5 h-5" />
                )}
                <span className="text-2xl font-bold">
                  {transaction.type === 'invoice' ? '+' : '-'}
                  {formatCurrency(transaction.amount)}
                </span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-6">
              <div className="card">
                <h3 className="text-sm text-gray-400 mb-1">Date</h3>
                <p>{new Date(transaction.date).toLocaleDateString()}</p>
              </div>
              <div className="card">
                <h3 className="text-sm text-gray-400 mb-1">Status</h3>
                <p className="capitalize">{transaction.status}</p>
              </div>
              <div className="card">
                <h3 className="text-sm text-gray-400 mb-1">Category</h3>
                <p>{transaction.category}</p>
              </div>
              <div className="card">
                <h3 className="text-sm text-gray-400 mb-1">Type</h3>
                <p className="capitalize">{transaction.type}</p>
              </div>
            </div>

            {transaction.description && (
              <div className="card">
                <h3 className="text-sm text-gray-400 mb-2">Description</h3>
                <p className="whitespace-pre-wrap">{transaction.description}</p>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-400">
            Transaction not found
          </div>
        )}
      </div>
    </Layout>
  );
}